/*
 * Module for the Benefit Payroll Supplement Register criteria page
 */
rs.module("content/reports/criteria/benefitpayrollsupplementregistercriteria",

    ["controls/data/grid"],

    function (gridModule) {

        function initialize(lrsGridApi, jsSelectors, ajaxUrls) {
            var filter = $.js(jsSelectors.filter);
            var includeManualCheckBox = filter.js(jsSelectors.includeManualCheckBox);
            var includeLumpSumsCheckBox = filter.js(jsSelectors.includeLumpSumsCheckBox);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            includeManualCheckBox.change(filterCheckBoxChanged);
            includeLumpSumsCheckBox.change(filterCheckBoxChanged);

            // refresh the grid based on checkbox selection
            function filterCheckBoxChanged() {
                loadingSpinner.show();
                gridModule.update(
                    ajaxUrls.refreshGridUrl,

                    { includeManualPayroll: includeManualCheckBox.is(':checked'), includeLumpSums: includeLumpSumsCheckBox.is(':checked') },

                    lrsGridApi.agGridApi,

                    function done() {
                        loadingSpinner.hide();
                    }
                );
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);